import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";


const SpaBooking2 = (props) => {

    const { t } = props
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");

    let imagePath;

    const handleNext = (selectedServiceGroup) => {
        props.next(selectedServiceGroup)
    }
    
    useEffect(() => {
        
        console.log("knowing",props.currentWidgetObj)
        
        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "Select Spa Service - Page 1",
            { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "spaLocationId": props.spaLocationId },
            0,
            props.guestIsLoggedIn,
        );
    }, [])

    return (
        <section class="widgets spa-listing">

            <div class="widget-header">

                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }

                <div class="widget-header-title">{props.serviceGroupData.spaLocationName || props.currentWidgets.displayName}</div>
            </div>

            <div class="row">
                <div class="col sm-banner">
                    <div class="col sm-banner">
                        {props.serviceGroupData.map((iterator) => {

                            imagePath = iterator.imageName ? encodeURI(`${CMSPath}${iterator.imageName}`) : "";

                            return (
                                <a id={iterator.widgetType} className={'tile-sm thumbnails tile-container'}
                                    onClick={() => { handleNext(iterator) }}
                                >
                                    <div class="thumb-img">
                                        {imagePath ?
                                            <img src={imagePath}></img> :
                                            ""
                                        }
                                    </div>

                                    <div class="thumb-text">
                                        <p class="thumb-heading">{iterator.name}</p>
                                    </div>
                                </a>
                            )
                        })
                        }
                    </div>
                </div>
            </div>
        </section>
    )

}

const mapStateToProps = state => {
    return {
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(SpaBooking2));